import { Helmet } from 'react-helmet-async';

const SchemaMarkup = ({ type = 'organization', data = {} }) => {
  const schemas = {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Garden & Greenhouse",
      "url": "https://www.gardenandgreenhouse.com",
      "logo": "https://customer-assets.emergentagent.com/job_grow-master-5/artifacts/264bpae4_GardenAndGreenhouseLogo.jpg",
      "description": "Expert gardening tips, premium products, and AI-powered plant care advice since 1998",
      "foundingDate": "1998",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "contact@gardenandgreenhouse.com",
        "contactType": "Customer Service"
      },
      "sameAs": [
        "https://www.gardenandgreenhouse.net"
      ]
    },
    website: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Garden & Greenhouse",
      "url": "https://www.gardenandgreenhouse.com",
      "description": "Expert gardening advice, product recommendations, and comprehensive growing guides",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.gardenandgreenhouse.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    },
    article: {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": data.title || '',
      "description": data.description || '',
      "image": data.image || '',
      "author": {
        "@type": "Person",
        "name": data.author || 'Garden & Greenhouse Staff'
      },
      "publisher": {
        "@type": "Organization",
        "name": "Garden & Greenhouse",
        "logo": {
          "@type": "ImageObject",
          "url": "https://customer-assets.emergentagent.com/job_grow-master-5/artifacts/264bpae4_GardenAndGreenhouseLogo.jpg"
        }
      },
      "datePublished": data.datePublished || new Date().toISOString(),
      "dateModified": data.dateModified || new Date().toISOString(),
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": data.url || ''
      }
    },
    localbusiness: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": data.name || '',
      "image": data.image || '',
      "@id": data.url || '',
      "url": data.url || '',
      "telephone": data.phone || '',
      "address": {
        "@type": "PostalAddress",
        "streetAddress": data.streetAddress || '',
        "addressLocality": data.city || '',
        "addressRegion": data.state || '',
        "postalCode": data.zipCode || '',
        "addressCountry": "US"
      },
      "priceRange": data.priceRange || '$$',
      "aggregateRating": data.rating ? {
        "@type": "AggregateRating",
        "ratingValue": data.rating,
        "reviewCount": data.reviewCount || 0
      } : undefined
    },
    breadcrumb: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": data.items || []
    }
  };

  const schema = schemas[type] || schemas.organization;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
